import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Link } from 'react-router-dom'
import { AiFillEdit, AiOutlinePlus } from 'react-icons/ai'
import { activeStatus, fetchAllDataAPI, fetchAllDatasAPI, removeDataFromList } from '../utils/api'
import { toast } from 'react-toastify'
import LoadingSpinner from '../components/LoadingSpinner'
import Swal from 'sweetalert2'
import { VscTrash } from "react-icons/vsc";
import { Table } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const Designation = () => {
    const [designation, setDesignation] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const recordPerPage = 10;
    const lastIndex = currentPage * recordPerPage;
    const firstIndex = lastIndex - recordPerPage;
    const records = designation.slice(firstIndex, lastIndex);
    const npage = Math.ceil(designation.length / recordPerPage)
    const numbers = [...Array(npage + 1).keys()].slice(1)

    useEffect(() => {
        getDesignation();
    }, []);

    const getDesignation = () => {
        setIsLoading(true);
        fetchAllDataAPI(`hr-all-designation`).then((res) => {
            if (res.data.status === 1) {
                setIsLoading(false);
                setDesignation(...[res.data.designation]);
            }
            else {
                toast.error("Check you connection!!");
            }
        })
    }
    const handleStatusActive = (designationid) => {
        activeStatus('hr-active-designation-status', designationid).then((res) => {
            if (res.data.status === 1) {
                getDesignation();
            }
        })
    }
    const handleStatusInactive = (designationid) => {
        activeStatus('hr-inactive-designation-status', designationid).then((res) => {
            if (res.data.status === 1) {
                getDesignation();
            }
        })
    }
    const handleDesignationRemoveHr = (designationid) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                removeDataFromList('hr-remove-designation', designationid).then((res) => {
                    if (res.data.status === 1) {
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                        getDesignation();
                    }
                })
            }
            else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {
                Swal.fire(
                    'Cancelled',
                    'Your imaginary file is safe :)',
                    'error'
                )
            }
        })
    }
    return (
        <div className="designationPage">
            <Helmet>
                <title>SATKARTAR::HR::DESIGNATION</title>
            </Helmet>
            <ContentWrapper>
                <div className="card employeepage">
                    <h4 className="mb-0 text-uppercase">
                        All Designation
                        <Link to="/add-designation" className="btn btn-primary btnemployee"><AiOutlinePlus /> Add Designation</Link>
                    </h4>
                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <>
                                        {[...Array(5)].map((_, index) => (
                                            <tr key={index}>
                                                {Array.from({ length: 4 }).map((_, index) => (
                                                    <td key={index}><Skeleton animation="wave" variant="text" /></td>
                                                ))}
                                            </tr>
                                        ))}
                                    </>
                                ) : records.length > 0 ? (
                                    records?.map((designation, index) => (
                                        <tr key={designation?.designation_id}>
                                            <td>{index + 1}</td>
                                            <td>{designation?.designation_name}</td>
                                            <td>
                                                {(() => {
                                                    if (designation?.designation_status === "Active") {
                                                        return (
                                                            <span className="badge bg-success btnstatus" onClick={() => handleStatusActive(designation?.designation_id)}>Active</span>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <span className="badge bg-danger btnstatus" onClick={() => handleStatusInactive(designation?.designation_id)}>Inactive</span>
                                                        )
                                                    }
                                                })()}
                                            </td>
                                            <td>
                                                <div className="d-flex" style={{ gap: "5px" }}>
                                                    <Link to={`/edit-designation/${designation?.designation_id}`} className="btnEdit"><AiFillEdit /></Link>
                                                    <button className="btnDelete" onClick={() => handleDesignationRemoveHr(designation?.designation_id)}><VscTrash /></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))) : (
                                    <tr>
                                        <td className="text-center" colSpan={4}>Data not found...</td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </Table>
                        <nav className="pagination-container">
                            <ul className="pagination align-items-center">
                                <li className="total-orders ml-2">Total: {designation.length}</li>
                            </ul>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={perPage} disabled={currentPage === 1}>
                                        Previous
                                    </button>
                                </li>
                                {numbers.map((n) => {
                                    if (
                                        n === 1 ||
                                        n === npage ||
                                        Math.abs(currentPage - n) <= 2
                                    ) {
                                        return (
                                            <li key={n} className={`page-item ${currentPage === n ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => changePage(n)}>
                                                    {n}
                                                </button>
                                            </li>
                                        );
                                    } else if (
                                        (n === currentPage - 3 && n > 1) ||
                                        (n === currentPage + 3 && n < npage)
                                    ) {
                                        return (
                                            <li key={n} className="page-item">
                                                <span className="page-link">...</span>
                                            </li>
                                        );
                                    }
                                    return null;
                                })}
                                <li className={`page-item ${currentPage === npage ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={nextPage} disabled={currentPage === npage}>
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
    function perPage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changePage(id) {
        setCurrentPage(id)
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
}

export default Designation